
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bBXra", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable jsdoc/check-tag-names */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $l8wPz = parcelRequire("l8wPz");

var $11zX6 = parcelRequire("11zX6");


var $QXwxo = parcelRequire("QXwxo");


var $cMyWi = parcelRequire("cMyWi");


var $aHoC6 = parcelRequire("aHoC6");

var $KTiWz = parcelRequire("KTiWz");

var $dUm2W = parcelRequire("dUm2W");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");


var $jkcNT = parcelRequire("jkcNT");


var $jzDd9 = parcelRequire("jzDd9");


var $iIYTj = parcelRequire("iIYTj");


var $96p1s = parcelRequire("96p1s");


var $2bxao = parcelRequire("2bxao");


var $ijHEK = parcelRequire("ijHEK");


var $6FNab = parcelRequire("6FNab");


var $gBjHb = parcelRequire("gBjHb");


var $3uhT3 = parcelRequire("3uhT3");


var $8bJxr = parcelRequire("8bJxr");

function $cd98786871d48e77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd98786871d48e77$var$embedCardWrapperStyles = {
    name: "yjftov",
    styles: "width:100%;height:100%;> div{height:100%;}.loader-wrapper{height:100%;}margin:0 auto"
};
const $cd98786871d48e77$var$embedCardCenterWrapperStyles = {
    name: "456bw7",
    styles: "margin:24px 0"
};
function $cd98786871d48e77$var$EmbedCardInternal(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, layout: layout, width: width, isInsideOfBlockNode: isInsideOfBlockNode, rendererAppearance: rendererAppearance, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget } = props;
    const portal = (0, $3uhT3.usePortal)(props);
    const embedIframeRef = (0, $cozmU.useRef)(null);
    // Card/CardSSR's onClick — (e, { destinationUrl?, url? })
    const onClick = (0, $ijHEK.getCardClickHandler)(eventHandlers, url);
    // SmartCardEventClickHandler — (e, url?) => void — for CardErrorBoundary.
    // When the gate is off, fall back to the old behaviour (pass the same onClick as Card).
    const onConsumerClick = (0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping') ? (0, $6FNab.getEventHandler)(eventHandlers, 'smartCard') : onClick;
    const { actionOptions: actionOptions } = smartLinks || {};
    const platform = 'web';
    const cardProps = {
        url: url,
        onClick: onClick,
        container: portal,
        platform: platform,
        frameStyle: smartLinks?.frameStyle ?? 'show',
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const [liveHeight, setLiveHeight] = (0, $cozmU.useState)(null);
    const [aspectRatio, setAspectRatio] = (0, $cozmU.useState)();
    const height = liveHeight || props.originalHeight;
    // We start with height and width defined with default values
    let originalHeight = (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
    let originalWidth = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH);
    // Then can override height and width with values from ADF if available
    if (props.originalHeight && props.originalWidth) {
        originalHeight = props.originalHeight;
        originalWidth = props.originalWidth;
    }
    // Then we can override it with aspectRatio that is comming from iframely via `resolve()`
    if (aspectRatio) {
        originalHeight = 1;
        originalWidth = aspectRatio;
    }
    // And finally if iframe sends live `height` events we use that as most precise measure.
    const isHeightOnlyMode = !(props.originalHeight && props.originalWidth) || liveHeight;
    if (height && isHeightOnlyMode) {
        originalHeight = height;
        originalWidth = undefined;
    }
    const padding = rendererAppearance === 'full-page' ? (0, $2bxao.FullPagePadding) * 2 : 0;
    const [hasPreview, setPreviewAvailableState] = (0, $cozmU.useState)(true);
    const cardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    const onResolve = ({ aspectRatio: resolvedAspectRatio })=>{
        const hasPreviewOnResolve = !!(cardContext && url && cardContext.extractors.getPreview(url, platform));
        if (!hasPreviewOnResolve) setPreviewAvailableState(false);
        setAspectRatio(resolvedAspectRatio);
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthConsumer), null, ({ width: documentWidth })=>{
        const isFullWidth = rendererAppearance === 'full-width';
        let containerWidth = documentWidth;
        if (smartLinks?.ssr && !containerWidth) // EDM-8114: When we are rendering on SSR, we have no idea what the width is.
        containerWidth = isFullWidth ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : (0, $7Y8M5.akEditorDefaultLayoutWidth);
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7Y8M5.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7Y8M5.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const lineLength = isFullWidth ? Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), containerWidth - padding) : nonFullWidthSize;
        const onError = ({ err: err })=>{
            if (err) throw err;
        };
        let cardComponent;
        if (smartLinks?.ssr && url && ((0, $iDrrr.fg)('platform_ssr_smartlink_embeds') || (0, $iDrrr.fg)('jfp-magma-ssr-iv-editor-links'))) {
            const ssrCardProps = {
                url: url,
                onClick: onClick,
                container: portal,
                platform: platform,
                frameStyle: smartLinks?.frameStyle ?? 'show',
                actionOptions: actionOptions
            };
            cardComponent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $QXwxo.CardSSR), {
                appearance: "embed",
                ...ssrCardProps,
                onResolve: onResolve,
                inheritDimensions: true,
                embedIframeRef: embedIframeRef,
                onError: onError
            });
        } else cardComponent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8wPz.Card), {
            appearance: "embed",
            ...cardProps,
            onResolve: onResolve,
            inheritDimensions: true,
            embedIframeRef: embedIframeRef,
            onError: onError
        });
        return(// Ignored via go/ees005
        /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url || '',
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).RENDERER
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $jzDd9.CardErrorBoundary), {
            unsupportedComponent: (0, $KTiWz.default),
            onSetLinkTarget: onSetLinkTarget,
            ...cardProps,
            onClick: onConsumerClick
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $11zX6.EmbedResizeMessageListener), {
            embedIframeRef: embedIframeRef,
            onHeightUpdate: setLiveHeight
        }, (()=>{
            const useCenterWrapper = layout === 'full-width' || layout === 'wide';
            const mediaSingle = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aHoC6.default), {
                layout: layout,
                width: originalWidth,
                containerWidth: containerWidth,
                pctWidth: width,
                height: originalHeight,
                fullWidthMode: isFullWidth,
                nodeType: "embedCard",
                lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
                hasFallbackContainer: hasPreview,
                isInsideOfInlineExtension: isInsideOfInlineExtension
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: $cd98786871d48e77$var$embedCardWrapperStyles
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "embedCardView-content-wrap",
                "data-embed-card": true,
                "data-layout": layout,
                "data-width": width,
                "data-card-data": data ? JSON.stringify(data) : undefined,
                "data-card-url": url,
                "data-card-original-height": originalHeight
            }, cardComponent)));
            return useCenterWrapper ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER,
                css: $cd98786871d48e77$var$embedCardCenterWrapperStyles
            }, mediaSingle) : mediaSingle;
        })()))));
    }));
}
const $cd98786871d48e77$export$1135f3b0aac4c4ec = ({ url: url, data: data, eventHandlers: eventHandlers, portal: portal, originalHeight: originalHeight, originalWidth: originalWidth, width: embedWidth, layout: layout, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget })=>{
    const { width: width } = (0, $cozmU.useContext)((0, $dUm2W.WidthContext));
    const viewAsBlockCard = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8bJxr.default), {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        layout: layout,
        rendererAppearance: rendererAppearance,
        smartLinks: smartLinks,
        onSetLinkTarget: onSetLinkTarget
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)($cd98786871d48e77$var$EmbedCardInternal, {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        width: embedWidth,
        layout: layout,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        smartLinks: smartLinks,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        onSetLinkTarget: onSetLinkTarget
    });
};
const $cd98786871d48e77$var$EmbedCardWithCondition = (0, $8m50u.componentWithCondition)(()=>(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $cd98786871d48e77$export$1135f3b0aac4c4ec, $cd98786871d48e77$var$EmbedCardInternal);
var $cd98786871d48e77$export$2e2bcd8739ae039 = $cd98786871d48e77$var$EmbedCardWithCondition;
module.exports["default"] = $cd98786871d48e77$export$2e2bcd8739ae039;

});

parcelRegister("11zX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fa07988e74fc1b7d$export$8f5a73ba0d077b01 = 32;
class $fa07988e74fc1b7d$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $fa07988e74fc1b7d$export$3482036c37e627f4;

});


//# sourceMappingURL=embedCard.5a384fa6.js.map
